var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.getApng(_vm.useApng, _vm.apng, _vm.png)}})}
var staticRenderFns = []

export { render, staticRenderFns }